import { SVGProps } from 'react';

export const IconAnalytics = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='2 2 20 20'>
      <rect x='4' y='13' width='4' height='7' rx='1' fill='currentColor' />
      <rect x='10' y='4' width='4' height='16' rx='1' fill='currentColor' />
      <rect x='16' y='9' width='4' height='11' rx='1' fill='currentColor' />
    </svg>
  );
};
